<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span>FOR</span></p>
<p class="ded1"><span>EDITHA GARDNER</span></p>
<p class="ded1"><span>BIRMINGHAM</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?42d58c8e